import {
  Component, Inject, OnInit,
} from '@angular/core';
import {
  MAT_DIALOG_DATA, MatDialog, MatDialogRef,
} from '@angular/material/dialog';
import { UpdateCourseComponent } from '../../../course-catalog/components/update-course/update-course.component';
import { CatalogSuggestionsService } from 'src/app/services/catalog-suggestions.service';
import { ToastService } from 'src/app/services/toast.service';
import { LoadingSpinnerService } from 'src/app/services/loading-spinner.service';

@Component({
  selector: 'app-catalog-suggestions-response',
  templateUrl: './catalog-suggestions-response.component.html',
  styleUrls: [ './catalog-suggestions-response.component.scss'],
})
export class CatalogSuggestionsResponseComponent implements OnInit {
  course: any;
  approvalType: any;
  denialReason: any = '';

  constructor(
    public dialog: MatDialog,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<CatalogSuggestionsResponseComponent>,
    private catalogSuggestionsService: CatalogSuggestionsService,
    private toastService: ToastService,
    private loadingSpinnerService: LoadingSpinnerService,
  ) { }

  ngOnInit(): void {
      console.log('Data received in modal:', this.data); // ADD THIS
  console.log('Course object in ngOnInit:', this.course); // ADD THIS
    this.course = this.data.course;
    this.approvalType = this.data.approvalType;
    if (this.approvalType === 'approve') {
      this.dialog.closeAll();
      const editModal = this.dialog.open(UpdateCourseComponent, {
        data: { ...this.course, isCatalogSuggestionsApproval: true },
      })
      editModal.afterClosed().subscribe((result) => {
        if (result) {
          this.dialogRef.close('approved');
        }
      })
    }
  }

denySuggestion(): void {
  this.loadingSpinnerService.setIsLoading(true);

  const courseItemId =
    this.course?.CourseItems?.[0]?.courseItemId ??
    this.course?.CourseItems?.[0]?.id;

  if (!courseItemId) {
    this.toastService.setToast({
      text: 'Missing Course Item ID for this suggestion',
      type: 'error',
      dismissible: false,
    });
    this.loadingSpinnerService.setIsLoading(false);
    return;
  }

  const suggestionData = {
    courseId: this.course.id,
    courseItemId,
  };

  this.catalogSuggestionsService
    .denyCatalogSuggestion(suggestionData, this.denialReason)
    .subscribe({
      next: () => {
        this.toastService.setToast({
          text: 'Catalog Suggestion Denied',
          type: 'success',
          dismissible: false,
        });
        this.dialogRef.close('denied');
        this.loadingSpinnerService.setIsLoading(false);
      },
      error: (error) => {
        console.log('error', error);
        this.toastService.setToast({
          text: 'Error denying catalog suggestion',
          type: 'error',
          dismissible: false,
        });
        this.loadingSpinnerService.setIsLoading(false);
      },
    });
}



  closeModal(): void {
    this.dialogRef.close();
  }

}
